export const ACTIONS = {
  BIND_QUOTE: "Bind quote",
  BIND_ENDORSEMENT_QUOTE: "Bind endorsement",
  CANCEL_ENDORSEMENT_MANUAL: "Cancel endorsement manual",
  CANCEL_ENDORSEMENT: "Cancel endorsement",
  CHECK_DEDUCTIBLES: "Check deductibles",
  CHECK_RATES: "Check rates",
  CREATE_CLAUSE: "Create clause",
  CREATE_DRAFT_SUBMISSION: "Create draft submission",
  CREATE_ENDORSEMENT_MTA: "Create MTA endorsement",
  CREATE_ENDORSEMENT_BESPOKE: "Create bespoke endorsement",
  CREATE_MESSAGE: "Create message",
  CREATE_PRODUCT: "Create product",
  CREATE_RENEWAL: "Create renewal",
  CREATE_SCHEMA: "Create schema",
  CREATE_SUBMISSION: "Quote submission",
  DOWNLOAD_BDX: "Download bdx",
  DECLINE_TO_QUOTE_CONTRACT: "Decline to quote contract",
  EDIT_CLAUSE: "Edit clause",
  EDIT_BESPOKE: "Edit bespoke",
  PROCESS_REFERRAL: "Process referral",
  PROVIDE_COMMERCIAL_PRICE: "Provide commercial price",
  REFER_CONTRACT: "Refer contract",
  REJECT_CONTRACT_NOT_PROGRESSED: "Reject contract not progressed",
  REJECT_CONTRACT_NOT_TAKEN_UP: "Reject contract not taken up",
  REMOVE_CLAUSE: "Remove clause",
  UPDATE_CONTRACT_COMMISSION: "Update contract commission",
  UPDATE_DRAFT_SUBMISSION: "Update draft submission",
  UPDATE_SUBMISSION: "Update submission",
  UPLOAD_CONTRACT_ATTACHMENT: "Upload contract attachment",
  UPLOAD_MESSAGE_ATTACHMENT: "Upload message attachment",
  VIEW_AUDIT_LOG: "View audit log",
  VIEW_CLAUSE: "View clause",
  VIEW_CONCURRENT_USERS: "View concurrent users",
  VIEW_QUOTE_COMMISSION: "View quote commission",
  VIEW_QUOTE_NET_PREMIUM: "View quote net premium",
  VIEW_REFERRAL_REASONS: "View referral reasons",
  VIEW_REFERRALS_TAB: "View referrals tab",
  ADD_CANCELLATION_CLAUSE: "Add cancellation clause",
  GENERATE_BROKER_INVOICE: "Generate broker invoice",
  GENERATE_BROKER_JACKET: "Generate broker jacket",
  VIEW_REMUNERATION: "View remuneration",
};

export default ACTIONS;
